import { useSiteContent } from "@/lib/content";

export const Marquee = () => {
  const c = useSiteContent();
  const row = [...c.marquee_items, ...c.marquee_items];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-white/10 bg-[#12151C] py-4"
    >
      <div className="marquee-track flex w-max items-center gap-10 whitespace-nowrap">
        {row.map((item, i) => (
          <span
            key={i}
            className="flex items-center gap-10 text-[11px] font-mono uppercase tracking-[0.22em] text-slate-400"
          >
            {item}
            <span className="text-[var(--ekal-accent)]">◆</span>
          </span>
        ))}
      </div>
    </div>
  );
};
